// extracted by mini-css-extract-plugin
module.exports = {"expiry":"expiry_expiry__3OQF4","inlineExpiry":"expiry_inlineExpiry__2Yxor","warning":"expiry_warning__tsZUo"};